import { observer } from "mobx-react-lite";
import MainLayout, { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold } from "../../common/common-text";
import { useEffect, useState } from "react";
import CustomerReport from "../../model/homepage/CustomerReport";
import BTBox from "../../common/components/BTBox";
import { dialogStore } from "../../store/DialogStore";
import { sendCustomerReportReply } from "../../service/HomepageService";
import BTEmailEditor from "../../common/components/board/BTEmailEditor";
import Divider from "@mui/material/Divider";
import theme from "../../common/theme";

const CustomerReportsReply = () => {
    return (
        <MainLayout>
            <CustomerReportsReplyBody />
        </MainLayout>
    );
};

export default CustomerReportsReply;

const CustomerReportsReplyBody = observer(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const [customerReport, setCustomerReport] = useState<CustomerReport>();
  const [replyTitle, setReplyTitle] = useState<string>("");
  const [replyContents, setReplyContents] = useState<string>("");

    useEffect(() => {
        if (location.state) {
            setCustomerReport(location.state as CustomerReport);
        }

    }, [location.state]);

    const handleSave = async () => {
        if (!customerReport?.id) return;

        const updatedReport: CustomerReport = {
          ...customerReport,
          replyTitle: replyTitle,
          replyContents: replyContents,
          replyCompletedYn: true
        };

        try {
          await sendCustomerReportReply(customerReport.id, updatedReport);
          dialogStore.showDialog({
            title: "성공",
            message: "답변이 전송되었습니다.",
            onConfirm: () => navigate(-1)
          });
        } catch (error) {
          dialogStore.showDialog({
            title: "에러",
            message: "답변 전송 중 오류가 발생했습니다.",
            onConfirm: () => { }
          });
        }
    };

    return (
        <div style={{ width: '100%', minHeight: `calc(100vh - ${MAIN_RIGHT_TOP_HEIGHT})`, display: 'flex', flexDirection: 'column' }}>
            <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
                <TitleLargeMedium>BB열린소리 답변 작성</TitleLargeMedium>
                <BTBox height="24px" />

                {customerReport ? (
                    <VerticalLayout height={'auto'} paddingBottom={36}>
                        {/* 답변 작성 */}
                        <TitleMediumBold style={{ marginTop: "20px" }}>답변 작성</TitleMediumBold>
                        <BTBox height="16px" />

                        <div style={{ width: '100%' }}>
                            <BTEmailEditor
                              title={replyTitle}
                              contents={replyContents}
                              setTitle={setReplyTitle}
                              setContents={setReplyContents}
                              onSave={handleSave}
                            />
                        </div>
                    </VerticalLayout>
                ) : (
                  <div style={{ fontSize: '16px', color: '#999' }}>
                    조회할 신고건이 없습니다.
                  </div>
                )}
            </VerticalLayout>
        </div>
    );
});